import "./App.css";

function App() {
  return (
    <div className="app-shell">
      <header className="hero">
        <p className="eyebrow">TutorDMV · Empowering Students</p>
        <h1>Your Path to Academic Success Starts Here</h1>
        <p className="lede">
          At TutorDMV, we specialize in providing personalized tutoring services for students in the DMV area. Whether you need help with test preparation or academic support, our expert tutors are here to guide you every step of the way.
        </p>
        <div className="cta-row">
          <a href="/services" target="_self">
            Explore Our Services
          </a>
          <a href="/contact" target="_self" className="secondary">
            Get in Touch
          </a>
        </div>
      </header>

      <section className="cards">
        <article>
          <h2>Expert Test Preparation</h2>
          <p>
            Our experienced tutors provide tailored strategies and resources to help you excel in your exams and achieve your academic goals.
          </p>
        </article>
        <article>
          <h2>Personalized Academic Support</h2>
          <p>
            We offer one-on-one tutoring sessions designed to meet your unique learning needs, ensuring you gain confidence and mastery in your subjects.
          </p>
        </article>
        <article>
          <h2>Flexible Scheduling</h2>
          <p>
            With our convenient scheduling options, you can find the perfect time for your tutoring sessions, making it easier to balance your studies and other commitments.
          </p>
        </article>
      </section>
    </div>
  );
}

export default App;